<template>
  <v-container>
    <p class="font-weight-medium">
      Recordatorios:
    </p>
    <p>
      {{ messageNotification }}
    </p>
  </v-container>
</template>

<script>
import {
  notificationData,
  notificationActions
} from '@/modules/documents/store/notificationStoreHelpers'

export default {
  name: 'NotificationSettings',
  data() {
    return {
      checkNotification: true
    }
  },
  created() {
    this.loadPeriodicities()
  },
  computed: {
    ...notificationData
  },
  methods: {
    ...notificationActions,
    loadPeriodicities() {
      this.getPeriodicities()
    }
  }
}
</script>
